// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".packages-book-root:not(.confirm){padding-top:50px}", "",{"version":3,"sources":["webpack://./../../cap1-modules/packages-module/src/modules/book/styles.scss"],"names":[],"mappings":"AACE,kCACE,gBAAA","sourcesContent":[".packages-book-root {\n  &:not(.confirm) {\n    padding-top: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
